import { ReducerActionRotaSP } from 'store/modules/types';

import { Types, AtualizarMunicipioRequest } from './types';

export function atualizarMunicipioRequest(
	token: string,
	data: AtualizarMunicipioRequest,
): ReducerActionRotaSP {
	return {
		type: Types.ATUALIZAR_MUNICIPIO_REQUEST,
		token,
		payload: data,
	};
}
export function atualizarMunicipioSuccess(
	payload: object,
): ReducerActionRotaSP {
	return {
		type: Types.ATUALIZAR_MUNICIPIO_SUCCESS,
		payload,
	};
}
export function atualizarMunicipioFailure(): ReducerActionRotaSP {
	return {
		type: Types.ATUALIZAR_MUNICIPIO_FAILURE,
		payload: null,
	};
}
export function atualizarMunicipioClear(): ReducerActionRotaSP {
	return {
		type: Types.ATUALIZAR_MUNICIPIO_CLEAR,
		payload: null,
	};
}
